export default __webpack_public_path__ + "static/media/metamask_steps_5.68e8b838.png";